const navigateStates = {
  FirstRedirect: 'firstRedirect'
};

export default navigateStates;
